import { AccountSkeleton } from 'components/skeletons';
import { useUserContext } from 'context/user';
import dynamic from 'next/dynamic';
import { memo } from 'react';

import styles from './top-bar-auth.module.scss';
import { TopBarAuthProps } from './top-bar-auth.types';

const AccountMenu = dynamic(() => import('components/account-menu').then((res) => res.AccountMenu));

export const TopBarAuth = memo(({ extraLoggedInComponent, children }: TopBarAuthProps) => {
  const { user, isUserLoading, isUserInitializing, isAuthModalOpen } = useUserContext();
  if (isUserInitializing) {
    return <div className={styles.placeholder} />;
  }
  if (user && !isAuthModalOpen && !isUserInitializing) {
    return (
      <>
        {extraLoggedInComponent}
        <AccountMenu />
      </>
    );
  }
  if (isUserLoading) {
    return <AccountSkeleton />;
  }
  return <>{children}</>;
});

TopBarAuth.displayName = 'TopBarAuth';
